export default __webpack_public_path__ + "static/media/excelIcon.d697b5ec.svg";